/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { MatchTypes } from 'store/modules/bulletins_store/types';
import iconIaGradiente from 'assets/images/icone-ia-gradiente.svg';
import { Container } from './styles';

interface MatchCompatibilityBarProps {
  match: MatchTypes;
  showActions?: boolean;
}

const openPersonalizar = () => window.dispatchEvent(new CustomEvent('open-match-personalizar'));

const MatchCompatibilityBar: React.FC<MatchCompatibilityBarProps> = ({
  match,
  showActions = true,
}) => {
  const { indicadores } = match;
  const nItens = match.n_itens || 0;
  const compatibilidade = match.compatibilidade ?? 0;
  const itensCompativeis = match.itens_compativeis || [];
  const [showItens, setShowItens] = useState(false);

  /** Pills curtas de contexto, na ordem do protótipo (Figma 4:4633). Os itens
   *  do edital que casaram ficam atrás do contador clicável — descrições de
   *  edital são longas e roubariam o palco do objeto da licitação. */
  const pills: string[] = [];
  /* indicadores.regiao cobre selos gravados antes do campo novo. */
  if (match.regiao_atuacao ?? indicadores.regiao === 'Alta') pills.push('Região de atuação');

  const itensLabel = nItens >= 2 ? `${nItens} itens compatíveis` : '1 item compatível';
  const expansivel = itensCompativeis.length > 0;
  const tooltip = [nItens > 0 ? itensLabel : '', match.explicacao].filter(Boolean).join(' — ');

  return (
    <Container title={tooltip}>
      <div className="match-info">
        <span className="match-label">
          <img src={iconIaGradiente} alt="IA" width={26} height={24} />
          Licitação compatível
        </span>

        {/* Selo antigo não tem percentual: mostra o nível em vez de "0%". */}
        <span className={`match-nivel match-nivel--${match.prioridade.toLowerCase()}`}>
          {compatibilidade > 0
            ? `${compatibilidade}% COMPATÍVEL COM SEU PERFIL`
            : match.prioridade.toUpperCase()}
        </span>

        <div className="match-pills">
          {nItens > 0 && (
            <button
              type="button"
              className="match-pill match-pill--itens"
              disabled={!expansivel}
              aria-expanded={showItens}
              onClick={() => expansivel && setShowItens((v) => !v)}
            >
              {itensLabel}
              {expansivel && <span className="match-chevron">{showItens ? '▴' : '▾'}</span>}
            </button>
          )}
          {pills.map((pill) => (
            <span className="match-pill" key={pill}>
              {pill}
            </span>
          ))}
        </div>
      </div>

      {showActions && (
        <div className="match-actions">
          <button type="button" className="match-btn-video">
            Assistir vídeo explicativo
          </button>
          <button type="button" className="match-btn-personalizar" onClick={openPersonalizar}>
            <span>Personalizar</span>
          </button>
        </div>
      )}

      {showItens && (
        <ul className="match-itens-lista">
          {itensCompativeis.map((item) => (
            <li key={item}>
              <span className="match-check">✓</span>
              {item}
            </li>
          ))}
        </ul>
      )}
    </Container>
  );
};

export default MatchCompatibilityBar;
